


























import { Component, Vue } from 'vue-property-decorator';
import OJIter from '@/components/OJIter.vue';
import { IOJFeature } from '@/models/oj-intro';

@Component({
  name: 'oj-intro',
  components: {
    'oj-iter': OJIter,
  },
})
export default class OJIntro extends Vue {
  public features: IOJFeature[] = [
    {
      title: '精选的C/C++题库',
      synopsis: '我们发布高质量的C/C++题目\n基础巩固，提高水平\n总有适合您的那一道',
      illu: require('@/assets/ojfeature1.jpg'),
    }, {
      title: '详细的测评结果',
      synopsis: '您的每一次提交\n都会形成详细清楚的成绩报告\n直到您在下一次提交中取得进展',
      illu: require('@/assets/ojfeature2.jpg'),
    }, {
      title: '直观的个人分析',
      synopsis: '定时更新的做题情况和排名区间\n记录您的每一次进步\n帮助您更好地了解自己',
      illu: require('@/assets/ojfeature3.jpg'),
    }, {
      title: '友好的用户体验',
      synopsis: '用户永远是MOJ的核心\n我们着眼细节，追求品质\n只为让您拥有更好的使用体验',
      illu: require('@/assets/ojfeature4.jpg'),
    },
  ];
}
